import { Tag, Typography, Icon } from "@ann/web-components";
import { VehicleInfoContainer, VehicleInfoLeft, VehicleInfoRight, VehicleInfoImageWrapper, VehicleInfoInfoWrapper, VehicleInfoRow, VehicleInfoVINWrapper } from "./VehicleInformation.styled";

const VehicleInformation = ({ vehicle }) => {
    const info = vehicle;

    const handleCopyVIN = () => {
        if (info?.vin && navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(info.vin).catch(() => {
               
            });
        }
    };

    return (
        <VehicleInfoContainer>
            <VehicleInfoLeft>
                <VehicleInfoImageWrapper>
                    <img src='/ModelCar.png' alt='Model' />
                </VehicleInfoImageWrapper>
                <VehicleInfoInfoWrapper>
                    <VehicleInfoRow>
                        <Typography category='body' weight='regular' size='medium'>
                            $10,000
                        </Typography>
                        <Tag text="Score 95" color='informative' size='medium' />
                    </VehicleInfoRow>
                    <VehicleInfoRow>
                        <Typography category='subtitle' weight='bold' size='small'>
                            Alerts
                        </Typography>
                        <Tag text="Service Overdue" color='alert' size='medium' />
                    </VehicleInfoRow>
                    {info?.vin && (
                        <VehicleInfoRow>
                            <Typography category='subtitle' weight='bold' size='small'>
                                VIN
                            </Typography>
                            <VehicleInfoVINWrapper>
                                <Typography category='body' weight='regular' size='medium' color='body'>
                                    {info.vin}
                                </Typography>
                                <Icon 
                                    name="copy" 
                                    size="medium" 
                                    color='neutral' 
                                    onClick={handleCopyVIN}
                                    style={{ cursor: 'pointer' }}
                                />
                            </VehicleInfoVINWrapper>
                        </VehicleInfoRow>
                    )}
                    {/* {info?.licenseNumber && (
                        <VehicleInfoRow>
                            <Typography category='subtitle' weight='bold' size='small'>
                                License Plate
                            </Typography>
                            <Typography category='body' weight='regular' size='medium' color='body'>
                                {info.licenseNumber}
                            </Typography>
                        </VehicleInfoRow>
                    )} */}
                </VehicleInfoInfoWrapper>
            </VehicleInfoLeft>
            <VehicleInfoRight>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Last Mileage
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        46,588 mi
                    </Typography>
                </VehicleInfoRow>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Estimated Mileage
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        46,588 mi
                    </Typography>
                </VehicleInfoRow>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Last Service Date
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        May 22, 2024
                    </Typography>
                </VehicleInfoRow>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Purchased
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        New
                    </Typography>
                </VehicleInfoRow>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Purchased Fate
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        Jun 1, 2023
                    </Typography>
                </VehicleInfoRow>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Purchased Date
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        Jun 1, 2023
                    </Typography>
                </VehicleInfoRow>
                <VehicleInfoRow>
                    <Typography category='subtitle' weight='bold' size='small'>
                        Key Features
                    </Typography>
                    <Typography category='body' weight='regular' size='medium' color='body'>
                        Heated seats - Adaptive cruise · AWD
                    </Typography>
                </VehicleInfoRow>
                {info?.createdAt && (
                    <VehicleInfoRow>
                        <Typography category='subtitle' weight='bold' size='small'>
                            Created Date
                        </Typography>
                        <Typography category='body' weight='regular' size='medium' color='body'>
                            {new Date(info.createdAt).toLocaleDateString('en-US', { 
                                month: 'short', 
                                day: 'numeric', 
                                year: 'numeric' 
                            })}
                        </Typography>
                    </VehicleInfoRow>
                )}
                {info?.updatedAt && (
                    <VehicleInfoRow>
                        <Typography category='subtitle' weight='bold' size='small'>
                            Last Updated
                        </Typography>
                        <Typography category='body' weight='regular' size='medium' color='body'>
                            {new Date(info.updatedAt).toLocaleDateString('en-US', { 
                                month: 'short', 
                                day: 'numeric', 
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </Typography>
                    </VehicleInfoRow>
                )}
            </VehicleInfoRight>
        </VehicleInfoContainer>
    );
};

export default VehicleInformation;